import { StoredImageDTO } from 'src/common/models/image';

export enum BannerSubpage {
  E_LEARNING = 'E_LEARNING',
  COURSE_BUNDLE = 'COURSE_BUNDLE',
  ONLINE = 'ONLINE',
  CATEGORY = 'CATEGORY',
}

export enum BannerStatus {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export type BannerDTO = {
  bannerLogo: StoredImageDTO;
  categoryId: number;
  createDate: string;
  displayStatus: BannerStatus;
  id: number;
  link: string;
  subpage: BannerSubpage;
  title: string;
};
